var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.954 10.663C18.6096 9.60386 18.9702 8.38865 18.9982 7.1433C19.0263 5.89795 18.7208 4.66775 18.1135 3.58014C17.5062 2.49254 16.6192 1.5871 15.5443 0.957619C14.4693 0.328139 13.2457 -0.00247986 12 1.40046e-05H5C4.46957 1.40046e-05 3.96086 0.210728 3.58579 0.5858C3.21071 0.960873 3 1.46958 3 2.00001V22C3 22.5304 3.21071 23.0392 3.58579 23.4142C3.96086 23.7893 4.46957 24 5 24H15C16.5934 24.0017 18.1397 23.4592 19.3828 22.4624C20.6259 21.4656 21.4914 20.0742 21.8359 18.5185C22.1805 16.9627 21.9835 15.336 21.2776 13.9075C20.5717 12.479 19.3991 11.3343 17.954 10.663ZM7 4.00001H12C12.7956 4.00001 13.5587 4.31608 14.1213 4.87869C14.6839 5.4413 15 6.20436 15 7.00001C15 7.79566 14.6839 8.55873 14.1213 9.12134C13.5587 9.68394 12.7956 10 12 10H7V4.00001ZM15 20H7V14H15C15.7956 14 16.5587 14.3161 17.1213 14.8787C17.6839 15.4413 18 16.2044 18 17C18 17.7957 17.6839 18.5587 17.1213 19.1213C16.5587 19.6839 15.7956 20 15 20Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.305aee94e1a6e8c0d22fdffdf9b9af41.svg";
export { ForwardRef as ReactComponent };